// extracted by mini-css-extract-plugin
export var accordionContent = "SideBarItem-module--accordionContent--0436d";
export var accordionOpen = "SideBarItem-module--accordionOpen--ee895";
export var activeNumber = "SideBarItem-module--activeNumber--cd89f";
export var arrowActive = "SideBarItem-module--arrowActive--9d454";
export var arrowDown = "SideBarItem-module--arrowDown--958cf";
export var arrowRotated = "SideBarItem-module--arrowRotated--3c871";
export var experiencMobileCardContent = "SideBarItem-module--experiencMobileCardContent--3ee07";
export var experienceMobileCard = "SideBarItem-module--experienceMobileCard--41e53";
export var indicatorNumber = "SideBarItem-module--indicatorNumber--148a1";
export var kickerMargin = "SideBarItem-module--kickerMargin--be50e";
export var mobileCardImage = "SideBarItem-module--mobileCardImage--26cc6";
export var sidebar = "SideBarItem-module--sidebar--3fe1d";
export var sidebarBackgroundImage = "SideBarItem-module--sidebarBackgroundImage--4eeb1";
export var sidebarBtn = "SideBarItem-module--sidebarBtn--308fe";
export var sidebarCloseBtn = "SideBarItem-module--sidebarCloseBtn--cccd9";
export var sidebarContent = "SideBarItem-module--sidebarContent--35012";
export var sidebarItem = "SideBarItem-module--sidebarItem--612da";
export var sidebarOpen = "SideBarItem-module--sidebarOpen--83b3c";
export var titleContainer = "SideBarItem-module--titleContainer--dc9d5";
export var titleMargin = "SideBarItem-module--titleMargin--72672";